import { useTranslation } from 'react-i18next';

import FieldTextarea from '@/components/common/Field/FieldTextarea/Field';
import Textarea from '@/components/common/Input/Textarea/Textarea';
import { termsText } from '@/constants/terms';

import * as S from './style';

const ServiceTerms = () => {
	const { t } = useTranslation();

	return (
		<S.Container>
			<S.Title>{t('mypage.serviceTerms.title')}</S.Title>
			<FieldTextarea title="mypage.serviceTerms.title">
				<Textarea value={t(termsText)} />
			</FieldTextarea>
		</S.Container>
	);
};

export default ServiceTerms;
